import React, { useEffect } from 'react';
import { VLink } from "./AppDataContext";
import { Helmet } from "react-helmet";

export function Contact() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            <Helmet>
                <title>Contact Us</title>
            </Helmet>
            <main class="content-page">
            <section>
                <div class="container">
                    <div class="row">
                        <div class="col-12 pt-5">
                            <h1 class="h3">Questions? Get in touch.</h1>
                            <div class="divider"></div>

                            <h1 class="h3 mt-5">Interested in selling on Bid Next Door?</h1>
                            <div class="divider mt-2"></div>
                            <p  >
                                <em>Wondering about pricing, features, and getting started?<br />
                                    We've outlined the details for you.</em>
                            </p>
                            <p>
                                <VLink to="/sell" class="btn btn-fill btn-secondary mb-3">Sell With Us</VLink>
                            </p>
                            <h1 class="h3 mt-5">Have you reviewed our FAQs? </h1>
                            <div class="divider mt-2"></div>
                            <p  >
                                <em>Find answers to frequently asked questions to help you find your way around and get the most out of Bid Next Door.</em>
                            </p>
                            <p>
                                <VLink to="/faq" class="btn btn-fill btn-secondary mb-3">FAQs</VLink>
                            </p>
                            <h1 class="h3 mt-5">Questions about an auction? </h1>
                            <div class="divider mt-2"></div>
                            <p  >
                                <em>Auction Managers can answer questions about specific
                                    items and auction pickups.<br />Click "About the Seller” on
                                    an auction page to find their contact information. </em>
                            </p>

                            <h1 class="h3 mt-5 ">Still can't find what you're looking for? </h1>
                            <div class="divider mt-2"></div>
                            <p  >
                                <em>Contact Bid Next Door support</em>
                            </p>
                            <p>
                                <a href="mailto:support@bidnextdoor.com">support@bidnextdoor.com</a>
                            </p>
                        </div>
                    </div>
                </div>

            </section>

        </main >
            <section class="seller">
                <div class="container">
                    <div class="row align-items-center py-5 mt-5">
                        <div class="col seller--image justify-content-center">
                            <img src="images/top-banner-vector.png" alt="" title="" class="mx-auto w-100" />
                        </div>
                        <div class="col col-md-8 seller--content">
                            <div class="mx-auto py-3 px-3 py-md-5 px-md-5 seller--content__div">
                                <h4>Start Today!</h4>
                                <h2>Find TREASURES in YOUR Neighborhood</h2>

                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );

}
